import type { BusSearchForm } from '@search/trip/bus/BusSearchForm';
import type { FlightSearchForm } from '@search/trip/flight/FlightSearchForm';
import type { HotelSearchForm } from '@search/hotel/HotelSearchForm';
import type { TrainSearchForm } from '@search/trip/train/TrainSearchForm';

export const useFlightForm = () =>
    useSearchFormStore().flightForm as FlightSearchForm;
export const useHotelForm = () =>
    useSearchFormStore().hotelForm as HotelSearchForm;
export const useTrainForm = () =>
    useSearchFormStore().trainForm as TrainSearchForm;
export const useBusForm = () => useSearchFormStore().busForm as BusSearchForm;
export const useTaxiForm = () => useSearchFormStore().taxiForm as BusSearchForm;
